/* eslint-disable */
import huChannel0Image from '../assets/channels/hu/0.png';
import huChannel1Image from '../assets/channels/hu/1.png';
import huChannel2Image from '../assets/channels/hu/2.png';
import huChannel3Image from '../assets/channels/hu/3.png';
import huChannel4Image from '../assets/channels/hu/4.png';
import huChannel5Image from '../assets/channels/hu/5.png';
import huChannel6Image from '../assets/channels/hu/6.png';

import huVideoPoster from '../assets/video/hu/video.jpg';
import huVideoWebm from '../assets/video/hu/video.webm';
import huVideoMp4 from '../assets/video/hu/video.mp4';
import huVideoOgv from '../assets/video/hu/video.ogv';

import roChannel0Image from '../assets/channels/ro/0.png';
import roChannel1Image from '../assets/channels/ro/1.png';
import roChannel2Image from '../assets/channels/ro/2.png';
import roChannel3Image from '../assets/channels/ro/3.png';
import roChannel4Image from '../assets/channels/ro/4.png';
import roChannel5Image from '../assets/channels/ro/5.png';

import roVideoPoster from '../assets/video/ro/video.jpg';
import roVideoWebm from '../assets/video/ro/video.webm';
import roVideoMp4 from '../assets/video/ro/video.mp4';
import roVideoOgv from '../assets/video/ro/video.ogv';

import bgChannel0Image from '../assets/channels/bg/0.png';
import bgChannel1Image from '../assets/channels/bg/1.png';

import bgVideoPoster from '../assets/video/bg/video.jpg';
import bgVideoWebm from '../assets/video/bg/video.webm';
import bgVideoMp4 from '../assets/video/bg/video.mp4';
import bgVideoOgv from '../assets/video/bg/video.ogv';

import czChannel0Image from '../assets/channels/cz/0.png';
import czChannel1Image from '../assets/channels/cz/1.png';
import czChannel2Image from '../assets/channels/cz/2.png';

import czVideoPoster from '../assets/video/cz/video.jpg';
import czVideoWebm from '../assets/video/cz/video.webm';
import czVideoMp4 from '../assets/video/cz/video.mp4';
import czVideoOgv from '../assets/video/cz/video.ogv';

export default {
  'hu': {
    'schedule.pdf': '/schedule.pdf',
    'Shows': 'Műsorok',
    'Schedule': 'TV Műsor',
    'Video': 'Videó',
    'Find us': 'EPG',
    'Slogan.0': 'NÉZZ BE HOZZÁNK!',
    'Slogan.1': 'EGY ÚJ CSATORNA TELE VICCES RAJZFILMEKKEL',
    'Check out the nicktoons schedule and find out what you can not miss': 'Nézd meg a tv műsort, hogy ne maradj le a kedvenc műsoraidról!',
    'Download the schedule': 'TV Műsor',
    'Want to know more? see the video!': 'Nézd meg, kikkel találkozhatsz!',
    'Check where you can find us:': 'Hol elérhető a Nicktoons csatorna?',
    'Rise of Teenage Mutant Ninja Turtles': 'A Tini Nindzsa Teknőcök Felemelkedése',
    'The Penguins of Madagascar': 'A Madagaszkár Pingvinjei',
    'Kung Fu Panda - Legends of Awesomeness': 'Kung Fu Panda: A rendkívüliség legendája',
    'SpongeBob SquarePants': 'SpongyaBob Kockanadrág',
    'ALVINNN!!! and the Chipmunks': 'ALVINNN!!! és a mókusok',
    'Link.0.title': 'Adatvédelmi szabályzat',
    'Link.0.url': 'http://www.nickelodeon.hu/info/adatvedelmi-szabalyzat',
    'Link.1.title': 'Cookie szabályzat',
    'Link.1.url': 'http://www.nickelodeon.hu/info/cookie-szabalyzat',
    'Cookies.text': 'A Nickelodeon sütiket használ. <br><br>A sütik segítségével jobban megérthetjük, hogyan használja a webhelyet, javíthatjuk a böngészési élményét, továbbá hirdetéseket jeleníthetünk meg az Ön számára. A sütik használatára vonatkozó további információkért, illetve az Ön választási lehetőségeiért, <a style="margin:0" href="http://www.nickelodeon.hu/info/cookie-szabalyzat" target="_blank">kattintson ide</a>. Egyéb esetben, a ”Folytatás” gombra kattintva bezárhatja ezt a szalagot. Köszönjük az érdeklődést, és jó böngészést kívánunk!',
    'Cookies.button': 'FOLYTATÁS',
    'VideoPoster': huVideoPoster,
    'VideoWebm': huVideoWebm,
    'VideoMp4': huVideoMp4,
    'VideoOgv': huVideoOgv,
    'Channels': [
      { 'image': huChannel0Image, 'title': '313' },
      { 'image': huChannel1Image, 'title': '110' },
      { 'image': huChannel2Image, 'title': '58' },
      { 'image': huChannel3Image, 'title': '107' },
      // { 'image': huChannel4Image, 'title': 'YYY' },
      // { 'image': huChannel5Image, 'title': 'YYY' },
      // { 'image': huChannel6Image, 'title': 'YYY' },
    ],
    'Facebook': 'https://www.facebook.com/NickelodeonHungary',
    'Mail': 'mailto:info@nickelodeon.hu',
  },

  'ro': {
    'schedule.pdf': '/schedule.pdf',
    'Shows': 'Emisiuni',
    'Schedule': 'Program TV',
    'Video': 'Video',
    'Find us': 'EPG',
    'Slogan.0': 'FAVORIȚII VECHI ȘI NOI TE AȘTEAPTĂ ',
    'Slogan.1': 'CU MAI MULTĂ DISTRACȚIE',
    'Check out the nicktoons schedule and find out what you can not miss': 'Uită-te peste program pentru a fi la curent cu emisiunile tale preferate!',
    'Download the schedule': 'Program TV',
    'Want to know more? see the video!': 'Uită-te la video să vezi cu cine te poți întâlni!',
    'Check where you can find us:': 'Unde este disponibil Nicktoons?',
    'Rise of Teenage Mutant Ninja Turtles': 'Ascensiunea Țestoaselor Ninja',
    'The Penguins of Madagascar': 'Pinguinii din Madagascar',
    'Kung Fu Panda - Legends of Awesomeness': 'Kung Fu Panda: Legendele Teribilităţii',
    'SpongeBob SquarePants': 'SpongeBob Pantaloni Pătraţi',
    'ALVINNN!!! and the Chipmunks': 'ALVINNN!!! şi veverițele',
    'Link.0.title': 'Politica de confidențialitate',
    'Link.0.url': 'http://www.nickelodeon.ro/info/politica-de-confidentialitate',
    'Link.1.title': 'Politica cookie',
    'Link.1.url': 'http://www.nickelodeon.ro/info/despre-cookies',
    'Cookies.text': 'Nickelodeon utilizează module cookie.<br><br>Modulele cookie ne ajută să înțelegem modul în care interacționați cu site-ul nostru, să vă îmbunătățim experiența de navigare pe site și să vă oferim publicitate. Pentru informații suplimentare cu privire la modul în care utilizăm modulele cookie și la opțiunile pe care le aveți la dispoziție, vă rugăm să faceți <a style="margin:0" href="http://www.nickelodeon.ro/info/despre-cookies" target="_blank">clic aici</a>. De asemenea, puteți să faceți clic pe „Continuare” pentru a închide acest anunț. Vă mulțumim pentru vizită și vă dorim navigare plăcută.',
    'Cookies.button': 'CONTINUARE',
    'VideoPoster': roVideoPoster,
    'VideoWebm': roVideoWebm,
    'VideoMp4': roVideoMp4,
    'VideoOgv': roVideoOgv,
    'Channels': [
      { 'image': roChannel0Image, 'title': '511' },
      { 'image': roChannel1Image, 'title': '159' },
      { 'image': roChannel2Image, 'title': '99' },
      // { 'image': roChannel3Image, 'title': 'YYY' },
      // { 'image': roChannel4Image, 'title': 'YYY' },
      // { 'image': roChannel5Image, 'title': 'YYY' },
    ],
    'Facebook': 'https://www.facebook.com/NickelodeonRO',
    'Mail': 'mailto:sro@mtvne.com',
  },
  'bg': {
    'schedule.pdf': '/schedule.pdf',
    'Shows': 'Предавания',
    'Schedule': 'Програма',
    'Video': 'Видео',
    'Find us': 'За контакт',
    'Slogan.0': 'Лозунг',
    'Slogan.1': 'Следи програмата на Ник Туунс и виж какво не трябва да изпускаш',
    'Check out the nicktoons schedule and find out what you can not miss': 'Натисни за програма',
    'Download the schedule': 'Програма',
    'Want to know more? see the video!': 'Искаш да научиш повече? Виж видеото!',
    'Check where you can find us:': 'Разбери къде можеш да ни намериш:',
    'Rise of Teenage Mutant Ninja Turtles': 'Възходът на костенурките нинджа',
    'The Penguins of Madagascar': 'Пингвините от Мадагаскар',
    'Kung Fu Panda - Legends of Awesomeness': 'Кунг-Фу Панда: Легенди за страхотния боец',
    'SpongeBob SquarePants': 'Спондж Боб Квадратни Гащи',
    'ALVINNN!!! and the Chipmunks': 'Алвин и Катеричоците',
    'Link.0.title': 'Декларация за поверителност',
    'Link.0.url': 'https://static.bricodes.com/app-loud-house/bg/privacy.pdf',
    'Link.1.title': 'Политика за „бисквитките“',
    'Link.1.url': 'https://static.bricodes.com/app-loud-house/bg/cookies.pdf',
    'Cookies.text': 'С помощта на „бисквитките“ може по-лесно да разберем, как използвате сайта, може да подобрим удоволствието от сърфирането в глобалната мрежа, както и да покажем обяви, които може да Ви интересуват. За по-подробна информация по отношение на ползването на „бисквитките“, респективно за Вашите възможности за избор, кликнете <a style="margin:0" href="https://static.bricodes.com/app-loud-house/bg/cookies.pdf" target="_blank">тук</a>. В противен случай с цъкане на бутона "X" може да затворите тази лента. Благодарим Ви за проявения интерес и приятно сърфиране!“ . Egyéb esetben, a ”Folytatás” gombra kattintva bezárhatja ezt a szalagot. Köszönjük az érdeklődést, és jó böngészést kívánunk!',
    'Cookies.button': 'X',
    'VideoPoster': bgVideoPoster,
    'VideoWebm': bgVideoWebm,
    'VideoMp4': bgVideoMp4,
    'VideoOgv': bgVideoOgv,
    'Channels': [
      { 'image': bgChannel0Image, 'title': '' },
      { 'image': bgChannel1Image, 'title': '' },
    ],
    'Facebook': 'https://www.facebook.com/nickelodeonbulgaria/',
    'Mail': 'https://m.me/nickelodeon.bg',
  },
  'cz': {
    'schedule.pdf': '/schedule.pdf',
    'Shows': 'Pořady',
    'Schedule': 'Program',
    'Video': 'Video',
    'Find us': 'EPG',
    'Slogan.0': 'Nový kanál',
    'Slogan.1': 'nabitý animáky',
    'Check out the nicktoons schedule and find out what you can not miss': 'Mrkni na program Nicktoons a zjistíš, co si nemůžeš nechat ujít!',
    'Download the schedule': '',
    'Want to know more? see the video!': 'Chceš vedět víc? Koukni na video!',
    'Check where you can find us:': 'Kde nás najdeš',
    'Rise of Teenage Mutant Ninja Turtles': 'Vzestup Želv Ninja',
    'The Penguins of Madagascar': 'Tučňáci z Madagaskaru',
    'Kung Fu Panda - Legends of Awesomeness': 'Kung Fu Panda: Legendy o mazáctví',
    'SpongeBob SquarePants': 'SpongeBob v kalhotách',
    'ALVINNN!!! and the Chipmunks': 'Alvin a Chipmunkové',
    'Link.0.title': 'Ochrana soukromí',
    'Link.0.url': 'http://www.nick.tv/gsp.scenic/international/nickelodeon.cz/legal/Nickelodeon_Privacy_Policy.pdf',
    'Link.1.title': 'Použití cookies',
    'Link.1.url': 'http://www.nick.tv/gsp.scenic/international/nickelodeon.cz/legal/Nickelodeon_Cookie_Policy.pdf',
    'Cookies.text': 'Cookies nám pomáhají porozumět, jak komunikujete s naší stránkou, zlepšit prohlížení a poskytovat reklamu přímo pro Vás. Pro více informací o tom, jak používáme cookies a jaké máte možnosti, <a href="http://www.nick.tv/gsp.scenic/international/nickelodeon.cz/legal/Nickelodeon_Cookie_Policy.pdf" target="_new">klikněte zde</a>. V opačném případě můžete kliknout na „X" a uzavřít toto oznámení. Děkujeme za potvrzení a příjemné prohlížení!',
    'Cookies.button': 'X',
    'VideoPoster': czVideoPoster,
    'VideoWebm': czVideoWebm,
    'VideoMp4': czVideoMp4,
    'VideoOgv': czVideoOgv,
    'Channels': [
      { 'image': czChannel0Image, 'title': '120' },
      { 'image': czChannel1Image, 'title': 'DTH: 133' },
      { 'image': czChannel2Image, 'title': 'IPTV: 133' },
      // { 'image': czChannel3Image, 'title': '107' },
      // { 'image': huChannel4Image, 'title': 'YYY' },
      // { 'image': huChannel5Image, 'title': 'YYY' },
      // { 'image': huChannel6Image, 'title': 'YYY' },
    ],
    'Facebook': 'https://www.facebook.com/Nickelodeon',
    'Mail': 'mailto:sro@mtvne.com',
  }
};



// WEBPACK FOOTER //
// ./src/app/dictionary.js